<template>
  <div
    v-if="showPopup"
    @click.self="closePopup"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
  >
    <div class="bg-white rounded-lg shadow-2xl overflow-hidden" style="width: 800px; height: 560px; display: flex; flex-direction: column;">
      <div class="p-6 border-b border-gray-200 text-white rounded-t-lg" style="background-color: #2563EB; flex-shrink: 0;">
        <div class="flex items-start justify-between">
          <div class="flex-grow">
            <div class="flex items-center mb-2">
              <i class="pi pi-bell mr-2"></i>
              <span class="text-sm font-semibold">最新公告</span>
            </div>
            <h2 class="text-2xl font-bold">{{ stripHtml(newsData.news_title) }}</h2>
          </div>
          <button
            @click="closePopup"
            class="ml-4 w-8 h-8 rounded-full bg-white bg-opacity-30 hover:bg-opacity-50 flex items-center justify-center transition-colors"
          >
            <i class="pi pi-times"></i>
          </button>
        </div>
      </div>

      <div class="p-6 overflow-y-auto" style="flex: 1; min-height: 0;">
        <div class="flex items-center text-sm text-gray-500 mb-6 pb-4 border-b border-gray-200">
          <i class="pi pi-calendar mr-2"></i>
          發布日期：{{ newsData.date_added }}
        </div>

        <div class="prose max-w-none" v-html="newsData.news_content"></div>
      </div>

      <div class="p-6 border-t border-gray-200 bg-gray-50 rounded-b-lg" style="flex-shrink: 0;">
        <div class="flex items-center mb-4">
          <input
            type="checkbox"
            id="dontShowAgain"
            v-model="dontShowAgainChecked"
            class="w-4 h-4 text-blue-600 rounded focus:ring-blue-500"
          />
          <label for="dontShowAgain" class="ml-2 text-gray-700 cursor-pointer">
            不再顯示此公告
          </label>
        </div>
        <div class="flex justify-end">
          <button
            @click="closePopup"
            class="px-6 py-2 text-white rounded-lg hover:shadow-lg transition-shadow font-semibold" style="background-color: #2563EB;"
          >
            確認
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { newsApi } from '@/api/news.js'

export default {
  name: 'NewsPopup',
  data() {
    return {
      showPopup: false,
      newsData: null,
      dontShowAgainChecked: false
    }
  },
  methods: {
    checkLatestNews() {
      newsApi.getLatestPopup()
        .then((response) => {
          if (response.data && response.data.success && response.data.data) {
            this.newsData = response.data.data
            this.showPopup = true
          }
        })
        .catch((error) => {
          // Silent fail
        })
    },
    closePopup() {
      if (this.dontShowAgainChecked) {
        if (this.newsData && this.newsData.news_id) {
          newsApi.markAsRead(this.newsData.news_id)
            .then((response) => {
              if (response.data && response.data.success) {
                this.showPopup = false
                this.newsData = null
                this.dontShowAgainChecked = false
              }
            })
            .catch((error) => {
              // 即使失敗也關閉彈窗
              this.showPopup = false
              this.newsData = null
              this.dontShowAgainChecked = false
            })
        } else {
          this.showPopup = false
          this.newsData = null
          this.dontShowAgainChecked = false
        }
      } else {
        this.showPopup = false
        this.dontShowAgainChecked = false
      }
    },
    stripHtml(html) {
      if (!html) return ''
      const tmp = document.createElement('DIV')
      tmp.innerHTML = html
      return tmp.textContent || tmp.innerText || ''
    }
  }
}
</script>

<style scoped>
.prose {
  color: #374151;
  line-height: 1.75;
}

.prose img {
  max-width: 100%;
  height: auto;
  margin: 1.5rem 0;
  border-radius: 0.5rem;
}

.prose h1,
.prose h2,
.prose h3 {
  font-weight: 600;
  margin-top: 1.5rem;
  margin-bottom: 0.75rem;
  color: #111827;
}

.prose p {
  margin-bottom: 1rem;
}

.prose ul,
.prose ol {
  margin: 1rem 0;
  padding-left: 1.5rem;
}

.prose li {
  margin: 0.5rem 0;
}
</style>
